const AddTemplate = () => {
    return <div>Add Tamplate</div>;
};

export default AddTemplate;